/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gallery_Not_FoundInputs */

const en_us2_plan_gallery_not_found = /** @type {(inputs: Plan_Gallery_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This plan is no longer in the gallery.`)
};

const pt_br2_plan_gallery_not_found = /** @type {(inputs: Plan_Gallery_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este plano não está mais na galeria.`)
};

const pt_pt2_plan_gallery_not_found = /** @type {(inputs: Plan_Gallery_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este plano não está mais na galeria.`)
};

/** @type {(inputs: Plan_Gallery_Not_FoundInputs) => LocalizedString} */
const es_419_plan_gallery_not_found = en_us2_plan_gallery_not_found;

/** @type {(inputs: Plan_Gallery_Not_FoundInputs) => LocalizedString} */
const fr_fr2_plan_gallery_not_found = en_us2_plan_gallery_not_found;

/** @type {(inputs: Plan_Gallery_Not_FoundInputs) => LocalizedString} */
const de_de2_plan_gallery_not_found = en_us2_plan_gallery_not_found;

/** @type {(inputs: Plan_Gallery_Not_FoundInputs) => LocalizedString} */
const it_it2_plan_gallery_not_found = en_us2_plan_gallery_not_found;

/**
* | output |
* | --- |
* | "This plan is no longer in the gallery." |
*
* @param {Plan_Gallery_Not_FoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_gallery_not_found = /** @type {((inputs?: Plan_Gallery_Not_FoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gallery_Not_FoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_gallery_not_found(inputs)
	if (locale === "es-419") return es_419_plan_gallery_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_gallery_not_found(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_gallery_not_found(inputs)
	if (locale === "de-DE") return de_de2_plan_gallery_not_found(inputs)
	if (locale === "it-IT") return it_it2_plan_gallery_not_found(inputs)
	return en_us2_plan_gallery_not_found(inputs)
});
export { plan_gallery_not_found as "plan_gallery.not_found" }